module.exports = __webpack_public_path__ + "1240c14cbac05010c78f81057e09d3b9.png";